import React from 'react';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  position: relative;
  width: 100%;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #111;
  cursor: pointer;
  padding: 10px 14px;
  background-color: ${({ isSelected }) => (isSelected ? '#fffbe6' : '#fafafa')};
  border-radius: 8px;
  margin-bottom: 4px;
  transition: background-color 0.2s;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${({ isSelected }) => (isSelected ? '#ffcc00' : '#eee')};
`;

const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
  color: #999;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:focus {
    outline: none;
  }

  &:hover {
    transform: rotate(45deg);
  }
`;

const DropdownContainer = styled.div`
  padding-left: 16px;
  margin-top: 6px;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  width: 100%;
`;

const DropdownOption = styled.label`
  display: flex;
  align-items: center;
  padding: 8px 14px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  margin-bottom: 2px;
  border-radius: 6px;
  transition: background-color 0.2s;
  width: 100%;

  &:hover {
    color: #111;
    background-color: #f5f5f5;
  }

  @media (max-width: 600px) {
    font-size: 15px;
    padding: 8px 10px;
  }
`;

const CheckboxInput = styled.input`
  margin-right: 12px;
  cursor: pointer;
`;

const SelectedValuesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 6px;
`;

const SelectedValue = styled.div`
  margin-right: 6px;
  margin-bottom: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  background-color: ${({ isSelected }) => (isSelected ? '#111' : '#f0f0f0')};
  font-size: 12px;
  color: ${({ isSelected }) => (isSelected ? '#ffcc00' : '#333')};
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background-color: #E53935;
    color: #fff;
  }
`;

const SelectedValues = ({ selectedValues, handleRemove }) => {
  return (
    <SelectedValuesContainer>
      {selectedValues.map((value) => (
        <SelectedValue key={value} isSelected onClick={() => handleRemove(value)}>
          {value} ×
        </SelectedValue>
      ))}
    </SelectedValuesContainer>
  );
};

function CheckboxList({ values, onChange, title, checkedValues = [] }) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleChange = (event) => {
    const { name, checked } = event.target;

    if (checked) {
      onChange([...checkedValues, name]);
    } else {
      onChange(checkedValues.filter((v) => v !== name));
    }
  };

  const toggleCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  const handleRemove = (value) => {
    onChange(checkedValues.filter((v) => v !== value));
  };

  return (
    <CheckboxContainer>
      <CheckboxLabel onClick={toggleCollapse} isSelected={checkedValues.length > 0}>
        <h1 style={{ marginBottom: '1px', fontWeight: 'normal', fontSize: '16px' }}>{title}</h1>
        <CollapseButton>
          {isExpanded ? '−' : '+'}
        </CollapseButton>
      </CheckboxLabel>

      {checkedValues.length > 0 && (
        <SelectedValues selectedValues={checkedValues} handleRemove={handleRemove} />
      )}

      <DropdownContainer isOpen={isExpanded}>
        {values.map((value) => (
          <DropdownOption key={value} onClick={() => {
            if (checkedValues.includes(value)) {
              onChange(checkedValues.filter((v) => v !== value));
            } else {
              onChange([...checkedValues, value]);
            }
          }}>
            <CheckboxInput
              type="checkbox"
              name={value}
              checked={checkedValues.includes(value)}
              readOnly
            />
            {value}
          </DropdownOption>
        ))}
      </DropdownContainer>
    </CheckboxContainer>
  );
}

export default CheckboxList;
